import { Injectable } from '@angular/core';
import { Apollo, gql, Mutation } from 'apollo-angular';
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };

// Escrita à mão (o codegen aponta para um host fora do ar): remoção (soft-delete)
// de um anexo da ideia tradicional. O Kaizen remove por REST.

export type DeleteIdeaFileMutation = { deleteIdeaFile: { status: number; message: string } };
export type DeleteIdeaFileMutationVariables = Exact<{
  id: string;
}>;

export const DeleteIdeaFileDocument = gql`
    mutation DeleteIdeaFile($id: String!) {
  deleteIdeaFile(id: $id) {
    status
    message
  }
}
    `;

@Injectable({
  providedIn: 'root'
})
export class DeleteIdeaFileGQL extends Mutation<DeleteIdeaFileMutation, DeleteIdeaFileMutationVariables> {
  document = DeleteIdeaFileDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
